import * as React from 'react'
import { useState } from "react"
import { UseEALinks } from "../../hooks/use-EA-links"
import * as style from './EASeeForYourself.module.scss'
import Iframe from '../utils/iFrame'

const EASeeForYourself = () => {
    const { youTube_EA_ProxyBrushVid,
        youTube_EA_ProxyBrushThumb,
        youTube_EA_OralHygieneThumb,
        youTube_EA_OralHygieneVid,
        youTube_EA_RetainerCareThumb,
        youTube_EA_RetainerCareVid,
        youTube_EA_PokeyWireThumb,
        youTube_EA_PokeyWireVid
    } = UseEALinks()

    var videoIframe
    videoIframe = <Iframe source={youTube_EA_ProxyBrushVid} title="Proxy Brush Video" />; 
    const [active, setActive] = useState("")
    return (
    <>
        <div id="SeeForYourself" className={style.seeForYourSelfSection}>
            <div className="container h-100 align-items-center">
                <h1 className="text-center mt-3">See for Yourself</h1>
                <div className="row align-items-center">
                    <div className="col-12 col-md-3 col-lg-2">
                        <div className={style.vidListContainer}>
                            <div className={style.vidList}>
                                <div tabIndex={0} role="button" className={style.vidItem} onClick={() => setActive("ProxyVid")} onKeyDown={() => setActive("ProxyVid")}>
                                    <div className={style.thumb}>
                                        <img src={youTube_EA_ProxyBrushThumb} alt="Proxy Brush" />
                                    </div>
                                    <div className={style.desc}> 
                                        Proxy Brush
                                    </div>
                                </div>

                                <div role="button" tabIndex={0} className={style.vidItem} onClick={() => setActive("OralHygieneVid")} onKeyDown={() => setActive("OralHygieneVid")}>
                                    <div className={style.thumb}>
                                        <img src={youTube_EA_OralHygieneThumb} alt="Oral Hygiene" />
                                    </div>
                                    <div className={style.desc}>
                                        Oral Hygiene
                                    </div>
                                </div>

                                <div role="button" tabIndex={0} className={style.vidItem} onClick={() => setActive("RetainerCareVid")} onKeyDown={() => setActive("RetainerCareVid")}>
                                    <div className={style.thumb}>
                                        <img src={youTube_EA_RetainerCareThumb} alt="Retainer Care" />
                                    </div>
                                    <div className={style.desc}>
                                        Retainer Care
                                    </div>
                                </div>

                                <div role="button" tabIndex={0} className={style.vidItem} onClick={() => setActive("PokeyWireVid")} onKeyDown={() => setActive("PokeyWireVid")}>
                                    <div className={style.thumb}>
                                        <img src={youTube_EA_PokeyWireThumb} alt="Pokey Wire" />
                                    </div>
                                    <div className={style.desc}>
                                        Pokey Wire
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-9 col-lg-10">
                        <div className={style.vidContainer}>
                        {active === "ProxyVid" && <Iframe title="Proxy Brush Video" source={youTube_EA_ProxyBrushVid} /> }
                        {active === "OralHygieneVid" && <Iframe title="Oral Hygiene Video" source={youTube_EA_OralHygieneVid} /> }
                        {active === "RetainerCareVid" && <Iframe title="Retainer Care Video" source={youTube_EA_RetainerCareVid} /> }
                        {active === "PokeyWireVid" && <Iframe title="Pokey Wire Video" source={youTube_EA_PokeyWireVid} /> }
                        {active === "" && videoIframe }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}

export default EASeeForYourself